/**
 * CompletedAlbumCard — Phase C1 rewrite.
 *
 * The dashboard's completed-album row now uses the shared trophy-
 * variant of CollectionAlbumSnapshotCard in horizontal layout, so the
 * visual language matches My Collection · Hall of Fame and My Profile
 * · Hall of Fame verbatim.
 *
 * Existing count / progress values are preserved without
 * normalisation — Phase C2 owns the completed-count 0→total repair
 * per the user's phase boundary.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import CollectionAlbumSnapshotCard from "@/components/collector/CollectionAlbumSnapshotCard";

export default function CompletedAlbumCard({ card }) {
  const nav = useNavigate();
  return (
    <div
      data-testid={`dash-completed-${card.id}`}
      title={card.title}
    >
      <CollectionAlbumSnapshotCard
        album={card}
        variant="trophy"
        layout="horizontal"
        showCounts={false}
        onOpen={() => nav(`/dashboard/my-collection/albums/${card.id}`)}
      />
    </div>
  );
}
